<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" xl="4" lg="5" md="6" sm="8" class="pt-0">
        <v-card outlined>
          <v-card-title
            v-text="$t('account.activationTitle')"
            class="font-weight-bold primary--text"
          ></v-card-title>
          <v-divider></v-divider>
          <!-- Validate registration token -->
          <template v-if="isLoading">
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col
                class="text-h6 text-center"
                cols="12"
                v-text="$t('account.waintingAccountValidation')"
              >
              </v-col>
              <v-col cols="6">
                <v-progress-linear
                  color="secondary"
                  :indeterminate="isLoading"
                  rounded
                  height="6"
                ></v-progress-linear>
              </v-col>
            </v-row>
          </template>
          <template v-else-if="isValid">
            <v-row
              align-content="center"
              justify="center"
              no-gutters
              class="pa-4"
            >
              <v-icon large color="success" v-text="'done_outline'"></v-icon>
              <v-col
                class="text-body-1 text-center pb-4"
                cols="12"
                v-text="$t('account.accountValidate')"
              >
              </v-col>
              <v-col cols="12">
                <v-btn
                  block
                  color="primary"
                  depressed
                  @click="
                    () => {
                      $router.push({ name: 'home' });
                      $store.dispatch('navigation/openLoginView');
                    }
                  "
                  v-text="$t('login.logIn')"
                ></v-btn>
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-row
              align-content="center"
              justify="center"
              no-gutters
              class="pa-4"
            >
              <v-col cols="6" class="text-center pb-4">
                <v-icon large color="error" v-text="'error'"></v-icon>
              </v-col>
              <v-col
                class="text-h6 text-center pb-4"
                cols="12"
                v-text="$t('account.wrongActivationLink')"
              >
              </v-col>
              <v-col cols="12"
                ><router-link :to="{ name: 'home' }">
                  <v-btn
                    color="secondary"
                    depressed
                    v-text="$t('account.goBackToGemmici')"
                    block
                  ></v-btn>
                </router-link>
              </v-col>
            </v-row>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AccountService from "../../account/services/AccountService";
export default {
  props: {
    uid: {
      required: true,
      type: String
    },
    token: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      isLoading: true,
      isValid: false
    };
  },
  created() {
    AccountService.checkUserRegistrationLink(this.uid, this.token)
      .then(() => (this.isValid = true))
      .catch(() => {})
      .finally(() => (this.isLoading = false));
  }
};
</script>

<style scoped></style>
